import React, { useState, useCallback } from 'react';
import axios from 'axios';
import FileSaver from 'file-saver';
import PropTypes from 'prop-types';
import { Table } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import { Flex, Button, Loader } from 'nallian-shared-ui/lib/components';
import apiRoutes from '../../../../app/api/routes';

const LegalDocumentRow = ({ legalDocument }) => {
  const { t } = useTranslation();
  const [isDownloading, setDownloading] = useState(false);

  const handleDownload = useCallback(async () => {
    setDownloading(true);
    const { data } = await axios.get(apiRoutes.legalDocumentsDownload(legalDocument.id), {
      headers: { Accept: 'application/octet-stream' },
      responseType: 'blob',
    });

    if (data) {
      FileSaver.saveAs(data, legalDocument.id);
      setDownloading(false);
      return true;
    }

    setDownloading(false);
    return true;
  }, [legalDocument.id, setDownloading]);

  return (
    <Table.Row key={legalDocument.id}>
      <Table.Cell width="8">{legalDocument.title}</Table.Cell>
      <Table.Cell width="4">{legalDocument.revision}</Table.Cell>
      <Table.Cell width="4">
        <Button
          linkbutton
          loading={isDownloading}
          content={t('download')}
          onClick={handleDownload}
        />
      </Table.Cell>
    </Table.Row>
  );
};

LegalDocumentRow.propTypes = { legalDocument: PropTypes.object.isRequired };

const LegalDocsList = ({ legalDocuments, loading }) => {
  const { t } = useTranslation();

  return (
    <Flex fluid direction="column" margin="0.7rem 0 0 0">
      <Table basic="very">
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell width="8">{t('title')}</Table.HeaderCell>
            <Table.HeaderCell width="8">{t('revision')}</Table.HeaderCell>
            <Table.HeaderCell width="4" />
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {legalDocuments.map(l => (
            <LegalDocumentRow key={l.id} legalDocument={l} />
          ))}
          {loading && (
            <Flex fluid justifyContent="center">
              <Loader inline active />
            </Flex>
          )}
          {!loading && !legalDocuments?.length && (
            <Table.Row>
              <Table.Cell>{t('noDocumentsYet')}</Table.Cell>
            </Table.Row>
          )}
        </Table.Body>
      </Table>
    </Flex>
  );
};

LegalDocsList.propTypes = { legalDocuments: PropTypes.array, loading: PropTypes.bool };
LegalDocsList.defaultProps = { legalDocuments: [], loading: false };

export default LegalDocsList;
